import { html, render } from "lit-html";
import { Input } from "./input";

class CompleteScreen {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.dialog = document.querySelector(".dialog");
  }

  handleInput(key) {
    switch (key) {
      case " ":
      case "Enter":
      case "q":
        document.dispatchEvent(new CustomEvent("ui.transition", {
          detail: {
            command: "RestartGame",
          }
        }));
      break;
    }
    return false;
  }

  rescale() {
    return;
  }

  activate(context) {
    this.overlay.classList.add("is-visible");
    this.dialog.classList.add("is-visible");
    this.dialog.classList.add("is-alert");
    render(this.getDialogTemplate(context.message), this.dialog);
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.dialog.classList.remove("is-visible");
    this.dialog.classList.remove("is-alert");
  }

  getDialogTemplate(message) {
    return html`
      <h2>Turned to Stone</h2>
      <p>The giant looked upon itself in your mirror and that was enough to destroy it. As its power dissipates into cold marble stone, you see your father start to revive as the curse is lifted.</p>
      <p>Thanks for playing!</p>
    `;
  }

  render(stage) {
    return;
  }
}

export default CompleteScreen;
